import { CartPercentIcon } from './CartPercentIcon';

/**
 * author: Michael Irigoyen
 * id 0E548E6D-946B-4BBE-97FA-2021E2DFF61D
 * name cart-percent
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-percent.svg
 * tags
 * - Shopping 
 */
export const CartDiscountIcon = CartPercentIcon;
export default CartDiscountIcon